
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoPlayerConfigFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VideoPlayerConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoCloudPlayerId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoCloudAccountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoCloudPolicyKey"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":123}};
    doc.loc.source = {"body":"fragment VideoPlayerConfigFields on VideoPlayerConfig {\n  videoCloudPlayerId\n  videoCloudAccountId\n  videoCloudPolicyKey\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
